export default class Inert {
  /**
   * Adds or removes the `inert` attribute on a single element.
   *
   * The `inert` attribute makes the element and its children unfocusable
   * and inaccessible to assistive technologies.
   *
   * @param {HTMLElement} el - The element to modify.
   * @param {boolean} [hideElement=true] - If `true`, adds the `inert` attribute; if `false`, removes it.
   */
  static setInertAttr(el, hideElement = true) {
    if (!el) {
      return;
    }

    if (hideElement) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  /**
   * Adds or removes the `inert` attribute on multiple elements.
   *
   * @param {HTMLElement[]} elements - Array of elements to modify.
   * @param {boolean} [hideElements=true] - If `true`, adds the `inert` attribute to each element; if `false`, removes it.
   */
  static setInertAttrOnElements(elements, hideElements = true) {
    elements.forEach(el => Inert.setInertAttr(el, hideElements));
  }
}
